/*
 * このソースコードはblanco Frameworkによって作成されました。
 */
import {
  RuleParamSchema,
  ValidationMessageTemplate,
  ValidationRuleFunction,
  ValidationRuleSchema,
} from "vee-validate/dist/types/types"

import { delimiterItemAmpersandValidator } from "./delimiterItemAmpersandValidator"
import { customMessage } from "./validatorUtil"

/**
 * VeeValidateのValidateRuleSchemaの実装クラスです。
 *
 * カスタムルール delimiterItemAmpersandの定義です。
 */
export class DelimiterItemAmpersandRuleSchema implements ValidationRuleSchema {
  validate: ValidationRuleFunction = (value, params) => {
    return delimiterItemAmpersandValidator(value, params)
  }
  params: RuleParamSchema[] = [
    "item1Name",
    "item1Max",
    "item1CheckHash",
    "item1ValidationMessage",
    "item2Name",
    "item2Max",
    "item2CheckHash",
    "item2ValidationMessage",
  ]
  message: ValidationMessageTemplate = (field: string, params?: Record<string, any>) => {
    return customMessage(field, params, [
      "item1Name",
      "item1Max",
      "item1CheckHash",
      "item1ValidationMessage",
      "item2Name",
      "item2Max",
      "item2CheckHash",
      "item2ValidationMessage",
    ])
  }
}
